import { sectionRenderer } from '@theme/section-renderer';

class DeliveryAwareSection extends HTMLElement {
  connectedCallback() {
    document.addEventListener('delivery-changed', this.#handleDeliveryChanged);
  }

  disconnectedCallback() {
    document.removeEventListener('delivery-changed', this.#handleDeliveryChanged);
  }

  #handleDeliveryChanged = async () => {
    const { sectionId } = this.dataset;
    if (!sectionId) return;

    const loader = this.closest('.shopify-section')?.querySelector('.delivery-loader');
    loader?.classList.add('_loading');

    try {
      await sectionRenderer.renderSection(sectionId, { cache: false });
    } catch (error) {
      console.error('delivery-aware-section: re-render failed', error);
    } finally {
      loader?.classList.remove('_loading');
    }
  };
}

if (!customElements.get('delivery-aware-section')) {
  customElements.define('delivery-aware-section', DeliveryAwareSection);
}
